// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Popup_popup__Oqmpp {
    position: fixed;
    bottom: 10px;
    right: 10px;
    width: 35%;
    background-color: white;
    padding: 20px;
    border-radius: 10px;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.5);
    z-index: 9999;
}
.Popup_container__g4PJh {
    width: 100%;
}
.Popup_emailField__g7DoT {
    font-family: 'Aktiv Grotesk', sans-serif;
    width: 90%;
    padding: 10px;
    margin: 10px 0;
    border-radius: 5px;
    border: 1px solid #ccc;
}
.Popup_buttonContainer__qJhxV {
    display: flex;
    gap: 10px;
    justify-content: flex-end;
}
.Popup_closeButton__SyOIl, .Popup_submitButton__RN2fe {
    margin-top: 15px;
    background-color: rgb(106, 191, 75);
    color: white;
    font-family: 'Cocon Bold';
    font-size: 14px;
    padding: 10px 15px;
    border-radius: 999px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    cursor: pointer;
    vertical-align: middle;
    border: none;
}
.Popup_disclaimer__y0Oab {
    font-size: 12px;
    color: #666;
    margin-top: 10px;
}
.Popup_questionField__pIMZk {
    width: 90%;
    padding: 10px;
    margin: 10px 0;
    border-radius: 5px;
    border: 1px solid #ccc;
    font-family: 'Aktiv Grotesk', sans-serif;

}

@media only screen and (max-width: 600px) {
    .Popup_popup__Oqmpp {
      bottom: 10px;
      right: 0;
      left: 0;
      width: 55%;
      background-color: white;
      padding: 20px;
      border-radius: 10px;
      box-shadow: rgba(0, 0, 0, 0.5) 0px 2px 5px;
      z-index: 9999;
      margin: 0 auto;
      position: absolute;
    }
  }
  
  @media only screen and (max-width: 400px) {
    .Popup_popup__Oqmpp {
      width: 75%;
      top: 100px;
      bottom: auto;
    }
  
    .Popup_container__g4PJh h4 {
      font-size: 14px;
    }
  
    .Popup_buttonContainer__qJhxV button {
      padding: 8px 16px 8px 16px;
      font-size: 12px;
    }
  }`, "",{"version":3,"sources":["webpack://./src/components/.shared/Popup.module.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,YAAY;IACZ,WAAW;IACX,UAAU;IACV,uBAAuB;IACvB,aAAa;IACb,mBAAmB;IACnB,wCAAwC;IACxC,aAAa;AACjB;AACA;IACI,WAAW;AACf;AACA;IACI,wCAAwC;IACxC,UAAU;IACV,aAAa;IACb,cAAc;IACd,kBAAkB;IAClB,sBAAsB;AAC1B;AACA;IACI,aAAa;IACb,SAAS;IACT,yBAAyB;AAC7B;AACA;IACI,gBAAgB;IAChB,mCAAmC;IACnC,YAAY;IACZ,yBAAyB;IACzB,eAAe;IACf,kBAAkB;IAClB,oBAAoB;IACpB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,eAAe;IACf,sBAAsB;IACtB,YAAY;AAChB;AACA;IACI,eAAe;IACf,WAAW;IACX,gBAAgB;AACpB;AACA;IACI,UAAU;IACV,aAAa;IACb,cAAc;IACd,kBAAkB;IAClB,sBAAsB;IACtB,wCAAwC;;AAE5C;;AAEA;IACI;MACE,YAAY;MACZ,QAAQ;MACR,OAAO;MACP,UAAU;MACV,uBAAuB;MACvB,aAAa;MACb,mBAAmB;MACnB,0CAA0C;MAC1C,aAAa;MACb,cAAc;MACd,kBAAkB;IACpB;EACF;;EAEA;IACE;MACE,UAAU;MACV,UAAU;MACV,YAAY;IACd;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,0BAA0B;MAC1B,eAAe;IACjB;EACF","sourcesContent":[".popup {\n    position: fixed;\n    bottom: 10px;\n    right: 10px;\n    width: 35%;\n    background-color: white;\n    padding: 20px;\n    border-radius: 10px;\n    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.5);\n    z-index: 9999;\n}\n.container {\n    width: 100%;\n}\n.emailField {\n    font-family: 'Aktiv Grotesk', sans-serif;\n    width: 90%;\n    padding: 10px;\n    margin: 10px 0;\n    border-radius: 5px;\n    border: 1px solid #ccc;\n}\n.buttonContainer {\n    display: flex;\n    gap: 10px;\n    justify-content: flex-end;\n}\n.closeButton, .submitButton {\n    margin-top: 15px;\n    background-color: rgb(106, 191, 75);\n    color: white;\n    font-family: 'Cocon Bold';\n    font-size: 14px;\n    padding: 10px 15px;\n    border-radius: 999px;\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    cursor: pointer;\n    vertical-align: middle;\n    border: none;\n}\n.disclaimer {\n    font-size: 12px;\n    color: #666;\n    margin-top: 10px;\n}\n.questionField {\n    width: 90%;\n    padding: 10px;\n    margin: 10px 0;\n    border-radius: 5px;\n    border: 1px solid #ccc;\n    font-family: 'Aktiv Grotesk', sans-serif;\n\n}\n\n@media only screen and (max-width: 600px) {\n    .popup {\n      bottom: 10px;\n      right: 0;\n      left: 0;\n      width: 55%;\n      background-color: white;\n      padding: 20px;\n      border-radius: 10px;\n      box-shadow: rgba(0, 0, 0, 0.5) 0px 2px 5px;\n      z-index: 9999;\n      margin: 0 auto;\n      position: absolute;\n    }\n  }\n  \n  @media only screen and (max-width: 400px) {\n    .popup {\n      width: 75%;\n      top: 100px;\n      bottom: auto;\n    }\n  \n    .container h4 {\n      font-size: 14px;\n    }\n  \n    .buttonContainer button {\n      padding: 8px 16px 8px 16px;\n      font-size: 12px;\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"popup": `Popup_popup__Oqmpp`,
	"container": `Popup_container__g4PJh`,
	"emailField": `Popup_emailField__g7DoT`,
	"buttonContainer": `Popup_buttonContainer__qJhxV`,
	"closeButton": `Popup_closeButton__SyOIl`,
	"submitButton": `Popup_submitButton__RN2fe`,
	"disclaimer": `Popup_disclaimer__y0Oab`,
	"questionField": `Popup_questionField__pIMZk`
};
export default ___CSS_LOADER_EXPORT___;
